import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async generate(event) {
    event.preventDefault()
    const button = event.currentTarget
    const originalText = button.textContent
    button.disabled = true
    button.textContent = "Generation..."

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json"
        }
      })

      if (!response.ok) throw new Error("Erreur serveur")

      const data = await response.json()
      this.prefillEmailModal(data.subject, data.body)
    } catch {
      button.textContent = "Erreur, reessayer"
      setTimeout(() => { button.textContent = originalText }, 2000)
    } finally {
      button.disabled = false
    }
  }

  prefillEmailModal(subject, body) {
    const dialog = document.querySelector("[data-email-compose-target='dialog']")
    if (!dialog) return

    const subjectInput = dialog.querySelector("input[name='subject']")
    const bodyInput = dialog.querySelector("textarea[name='body']")

    if (subjectInput) subjectInput.value = subject
    if (bodyInput) bodyInput.value = body

    dialog.showModal()
  }
}
